export default "__VITE_ASSET__miZnnTKQ__"